import { Link } from "@/lib/router-compat";
import { segmentPages } from "@/config/segmentPages";

interface SegmentLinksProps {
  /** Path of the current page, so it is not linked to itself */
  currentPath?: string;
  heading?: string;
}

export function SegmentLinks({
  currentPath,
  heading = "Beliebte Kreditkarten-Vergleiche",
}: SegmentLinksProps) {
  const links = [
    ...segmentPages.map((page) => ({ path: page.path, label: page.h1 })),
    { path: "tools/kreditkarten-finder", label: "Kreditkarten-Finder: passende Karte in 5 Fragen" },
  ].filter((page) => page.path !== currentPath);

  if (links.length === 0) return null;

  return (
    <nav aria-label={heading} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h2 className="text-lg font-semibold text-gray-900 mb-3">{heading}</h2>
      <ul className="flex flex-wrap gap-2">
        {links.map((page) => (
          <li key={page.path}>
            <Link
              to={`/${page.path}`}
              className="inline-block rounded-full border border-border bg-card px-4 py-2 text-sm text-foreground hover:border-primary/50 transition-colors"
            >
              {page.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
